import router from '@/router';
import { fetchCount } from '@/features/AudienceManager/data';
import { saveExportAudience } from '@/features/AudienceManager/data';
const defaultState = () => ({
    creatorId: undefined,
    audienceId: undefined,
    audienceName: '',
    audienceDescription: '',
    audienceToken: null,
    activeStep: 1,
    count: {
        loading: false,
        people: undefined,
        score: null,
        token: '',
        error: false,
    },
    isConditionAdded: false,
    resetDebounceCount: false,
    pendingRequestCount: 0,
    error: {
        name: false,
    },
});
const audienceManagerBase = {
    namespaced: true,
    state: defaultState(),
    getters: {
        activeStep: state => state.activeStep,
        steps: (_, getters) => [
            { id: 1, key: 'composition', name: 'audiences.composition' },
            { id: 2, key: 'integration', name: 'audiences.integration.title' },
            ...(getters.isView ? [{ id: 3, key: 'historic', name: 'audiences.historic' }] : []),
        ],
        activeStepName: (_, getters) => {
            const getActiveStep = getters.steps.filter(step => step.id === getters.activeStep)[0];
            return getActiveStep?.key;
        },
        hasErrorAudienceName: state => state.error.name,
        getAudienceId: state => state.audienceId,
        getAudienceName: state => state.audienceName,
        isView: state => state.audienceId !== undefined && /^AudienceDetail(New)?$/.test(String(router.currentRoute.value.name)),
        audienceQuery: (_, __, ___, rootGetters) => rootGetters['audienceManager/query'],
        isQueryEmpty: (_, getters) => !Object.keys(getters.audienceQuery).length,
        getCount: state => state.count,
        totalPeople: state => state.count.people,
        isDuplicate: state => String(router.currentRoute.value.name) === 'AudienceDuplicateNew' || state.audienceId !== undefined,
    },
    actions: {
        changeStep({ commit }, stepId) {
            commit('SET_ACTIVE_STEP', stepId);
        },
        setCreator({ commit }, creatorID) {
            commit('SET_CREATORID', creatorID);
        },
        setAudienceID({ commit }, audienceId) {
            commit('SET_AUDIENCEID', audienceId);
        },
        resetBaseState({ commit }) {
            commit('RESET_BASE_STATE');
        },
        resetCountStateIfQueryEmpty(state, commit) {
            state.count.score = null;
            state.count.people = null;
            commit('UPDATE_COUNT_LOADING', false);
            state.pendingRequestCount = 0;
        },
        saveExportAudience({ state, getters, dispatch }, selectedColumnsKeys) {
            const audienceId = getters.audienceId;
            saveExportAudience(audienceId, selectedColumnsKeys)
                .then(data => {
                state.batchId = data?.batchId;
                dispatch('fetchExportationStatus');
            })
                .catch(() => {
                state.modalState.progress = true;
                setTimeout(() => (state.modalState.error = true), 300);
            });
        },
        triggerDebounceReset({ state, dispatch, commit, getters }) {
            clearTimeout(state.debounceTimer);
            if (getters.isQueryEmpty && !getters.isView)
                return;
            if (!state.isConditionAdded)
                return;
            if (state.isConditionAdded)
                commit('UPDATE_COUNT_LOADING', true);
            state.debounceTimer = setTimeout(() => {
                state.pendingRequestCount++;
                commit('UPDATE_COUNT_LOADING', true);
                dispatch('updateCount');
            }, 2500);
        },
        updateCount({ state, getters, dispatch, commit }) {
            state.count.error = false;
            if (getters.isQueryEmpty && !getters.isView)
                return;
            commit('UPDATE_COUNT_LOADING', true);
            const DUPLICATE_CREATION_MODE = !getters.isView && getters.isDuplicate;
            fetchCount(getters.audienceQuery, DUPLICATE_CREATION_MODE ? null : state.audienceId)
                .then(response => {
                if (!response || !response?.success) {
                    state.count.error = true;
                    return;
                }
                state.count.people = response.data.count;
                state.count.token = response.data.token;
                state.count.score = response.data.score;
            })
                .finally(() => {
                state.pendingRequestCount = Math.max(0, state.pendingRequestCount - 1);
                if (state.pendingRequestCount === 0) {
                    commit('UPDATE_COUNT_LOADING', false);
                    commit('IS_CONDITION_ADDED', false);
                }
                if (getters.isQueryEmpty && !getters.isView) {
                    dispatch('resetCountStateIfQueryEmpty');
                }
            });
        },
    },
    mutations: {
        SET_CREATORID(state, creator) {
            state.creatorId = creator;
        },
        SET_AUDIENCEID(state, audienceId) {
            state.audienceId = audienceId;
        },
        SET_AUDIENCE_NAME(state, name) {
            state.audienceName = name;
        },
        SET_TOKEN(state, token) {
            state.audienceToken = token;
        },
        SET_ACTIVE_STEP(state, step) {
            state.activeStep = step;
        },
        SET_RESET_DEBOUNCE(state, value) {
            state.resetDebounceCount = value;
        },
        SET_ERROR_AUDIENCE_NAME(state, hasError) {
            state.error.name = hasError;
        },
        UPDATE_COUNT_LOADING(state, value) {
            state.count.loading = value;
        },
        IS_CONDITION_ADDED(state, value) {
            state.isConditionAdded = value;
        },
        RESET_BASE_STATE(state) {
            Object.assign(state, defaultState());
        },
    },
};
export default audienceManagerBase;
